import { Site } from "@inrange/building-manager-api-client/models-site";
import { Column, NoPaddedRow, PageCardHeader } from "@inrange/theme-components";
import {
  formatBatterySummary,
  formatUnits,
} from "@inrange/theme-components/formatting";
import {
  LeaseComparisonItem,
  LicenseComparisonItem,
} from "@inrange/theme-components/leaseLicenseComparison";
import React from "react";

interface LeaseLicenseChoiceSummaryProps {
  site: Site;
  updateInvestmentModel: (model: "license" | "lease") => void;
  irr?: number;
  totalBuildingAreaM2: number;
  paybackMonths?: number;
  isOwnerOccupier: boolean;
}

const LeaseLicenseChoiceSummary: React.FC<LeaseLicenseChoiceSummaryProps> = ({
  site,
  updateInvestmentModel,
  irr,
  totalBuildingAreaM2,
  paybackMonths,
  isOwnerOccupier,
}) => {
  return (
    <>
      <Column>
        <PageCardHeader
          title="Select an investment model"
          label="This is not a commitment, and you can switch between models as you see fit."
        />
      </Column>
      <NoPaddedRow style={{ marginRight: 34 }}>
        <LicenseComparisonItem
          irr={irr}
          paybackMonths={paybackMonths}
          annualRevenue={
            isOwnerOccupier
              ? site.financialModels.ownerOccupier.license.revenue
              : site.financialModels.landlord.license.revenue
          }
          pvHardwareLabel={`${formatUnits(site.totalInstalledCapacity, "kWp", 1)} PV hardware`}
          pvHardwareCosts={site.projectCosts.pvHardware}
          pvInstallationCosts={site.projectCosts.pvInstallation}
          batteryHardwareLabel={
            site.totalBatterySummary
              ? `${formatBatterySummary(site.totalBatterySummary)} battery`
              : undefined
          }
          batteryCosts={
            site.totalBatterySummary
              ? site.projectCosts.batteryHardware +
                site.projectCosts.batteryInstallation
              : undefined
          }
          enablingWorksCosts={
            site.costInputsPv.enablingWorksCosts + site.costInputsPv.wiringCosts
          }
          additionalCosts={
            site.projectCosts.additionalCosts > 0
              ? site.projectCosts.additionalCosts
              : undefined
          }
          initialInvestment={site.projectCosts.initialInvestment}
          setInvestmentModel={() => {
            updateInvestmentModel("license");
          }}
          currencyCode={site.currencyCode}
        />
        <LeaseComparisonItem
          annualRevenue={
            isOwnerOccupier
              ? site.financialModels.ownerOccupier.lease.revenue
              : site.financialModels.landlord.lease.revenue
          }
          pvHardwareLabel={`${formatUnits(site.totalInstalledCapacity, "kWp", 1)} PV hardware`}
          batteryHardwareLabel={
            site.totalBatterySummary
              ? `${formatBatterySummary(site.totalBatterySummary)} battery`
              : undefined
          }
          additionalCosts={
            site.projectCosts.additionalCosts > 0 ? 0 : undefined
          }
          totalBuildingAreaM2={totalBuildingAreaM2}
          setInvestmentModel={() => {
            updateInvestmentModel("lease");
          }}
          currencyCode={site.currencyCode}
          areaUnit={site.areaUnit}
        />
      </NoPaddedRow>
    </>
  );
};

export default LeaseLicenseChoiceSummary;
